export default "__VITE_ASSET__kx2fhwnR__"